module.exports = __webpack_public_path__ + "static/media/news-13.c1a0925f.jpg";